// extracted by mini-css-extract-plugin
export default {"carouselCard":"CarouselCard_carouselCard__B9Z2X","cardBody":"CarouselCard_cardBody__v8bd5"};